import {
    List,
    ListItem,
    useMultiStyleConfig
} from '@salesforce/retail-react-app/app/components/shared/ui'
import PropTypes from 'prop-types'
import React from 'react'
import {useIntl} from 'react-intl'
import {CheckCircleIcon, CheckCircleIconLight} from '@consteed/overrides/components/icons'
import {
    PRODUCT_FEATURES1,
    PRODUCT_FEATURES2,
    PRODUCT_FEATURES3,
    PRODUCT_FEATURES4
} from '@consteed/overrides/i18n/components/pageDesigner/ProductFeatures'

const ProductFeature = (props) => (
    <ListItem {...props.styles.checkmarkBenefitsListItem}>
        {props.hasLightBg && <CheckCircleIconLight {...props.styles.checkmark} />}
        {!props.hasLightBg && <CheckCircleIcon {...props.styles.checkmark} />}
        {props.children}
    </ListItem>
)
ProductFeature.propTypes = {
    hasLightBg: PropTypes.bool,
    children: PropTypes.object,
    styles: PropTypes.object
}

const ProductFeatures = ({hasLightBg = false}) => {
    const styles = useMultiStyleConfig('ProductFeatures', {hasLightBg})
    const {formatMessage} = useIntl()
    const formattingOptions = {
        strong: (chunks) => <strong>{chunks}</strong>
    }
    return (
        <List {...styles.checkmarkBenefits} spacing={3}>
            {[PRODUCT_FEATURES1, PRODUCT_FEATURES2, PRODUCT_FEATURES3, PRODUCT_FEATURES4].map(
                (PRODUCT_FEATURE, index) => (
                    <ProductFeature styles={styles} hasLightBg={hasLightBg} key={`feature${index}`}>
                        {formatMessage(PRODUCT_FEATURE, formattingOptions)}
                    </ProductFeature>
                )
            )}
        </List>
    )
}
ProductFeatures.propTypes = {
    hasLightBg: PropTypes.bool
}

export default ProductFeatures
